import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { chapters } from '../data/chapters';
export function Contents() {
  return <section className="w-full bg-cream py-16 sm:py-24" aria-labelledby="contenido-title" data-id="element-42" data-mp="osusjsukn419">
      <div className="mx-auto max-w-5xl px-5 sm:px-8" data-id="element-43" data-mp="12ogaxh6aupkp">
        <Reveal data-id="element-44" data-mp="xr6mo4uncjyg">
          <p className="text-xs font-semibold uppercase tracking-widest text-clay" data-id="element-45" data-mp="xqomix4v5ll9">
            Dentro del protocolo
          </p>
          <h2 id="contenido-title" className="mt-4 max-w-3xl font-display text-3xl font-semibold leading-tight tracking-tight text-bark sm:text-[2.6rem]" data-id="element-46" data-mp="1bp4sumytda2v">
            Los 7 capítulos que cambian tu biología
          </h2>
        </Reveal>

        <ol className="mt-12 space-y-4" data-id="element-47" data-mp="1ghfsdopn6tuw">
          {chapters.map((chapter, index) => <Reveal key={chapter.title} as="li" delay={Math.min(index * 0.03, 0.15)} data-id="element-48" data-mp="1vf84e6vzd04c" data-mpi={index}>
              <article className="rounded-2xl border border-bark/10 bg-sand/40 p-6 sm:p-8" data-id="element-49" data-mp="1vcu9pz57ppxb">
                <div className="flex flex-wrap items-baseline gap-x-3 gap-y-1" data-id="element-50" data-mp="1qe0xsb5kq6z9">
                  <span className="rounded-md bg-bark px-2.5 py-1 text-[11px] font-semibold uppercase tracking-widest text-cream" data-id="element-51" data-mp="1ftaqd58e83v5">
                    {chapter.label}
                  </span>
                  <span className="text-xs font-semibold uppercase tracking-widest text-clay" data-id="element-52" data-mp="1oquqgauiru46">
                    {chapter.kicker}
                  </span>
                </div>

                <h3 className="mt-4 font-display text-xl leading-snug text-bark sm:text-2xl" data-id="element-53" data-mp="1ypiweb98ciri">
                  {chapter.title}
                </h3>
                <p className="mt-3 max-w-3xl text-sm leading-relaxed text-ink/80 sm:text-base" data-id="element-54" data-mp="23nbzgvf8kwnk">
                  {chapter.description}
                </p>

                {chapter.blocks && <div className="mt-6 grid gap-5 sm:grid-cols-2" data-id="element-55" data-mp="2chgulr1eku8w">
                    {chapter.blocks.map(block => <div key={block.subtitle} className="rounded-xl bg-cream p-5 shadow-soft" data-id="element-56" data-mp="2himtk6lnpdqv">
                        <h4 className="text-xs font-semibold uppercase tracking-widest text-ink/60" data-id="element-57" data-mp="2mgo8cfc1uqwj">
                          {block.subtitle}
                        </h4>
                        <ul className="mt-3 space-y-2.5" data-id="element-58" data-mp="hfvceraitcl8">
                          {block.items.map(item => <li key={item} className="flex gap-2.5 text-sm leading-relaxed text-ink/80" data-id="element-59" data-mp="w48c9zcqbfl0">
                              <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-sageDeep" aria-hidden="true" data-id="element-60" data-mp="rcq8z4n8h2wv" />
                              <span data-id="element-61" data-mp="153da13ggv4w4">{item}</span>
                            </li>)}
                        </ul>
                      </div>)}
                  </div>}

                {chapter.note && <p className="mt-5 border-l-2 border-clay pl-4 font-display text-base leading-snug text-bark sm:text-lg" data-id="element-62" data-mp="1f345b7cupnx9">
                    {chapter.note}
                  </p>}
              </article>
            </Reveal>)}
        </ol>
      </div>
    </section>;
}